export default () => Math.round(Math.random() * 36 ** 12).toString(36)
